import React from 'react';
import '../less/main.less';
import AccordionItem from '../views/accordion-item.c';

export default function template() {
  const { items } = this.props;

  return (
    <div className="accordion">
      <div className="container">
        <div className="accordion__body">
          {items.map((item, index) => (
            <AccordionItem key={index} item={item}/>
          ))}
        </div>
      </div>
    </div>
  );
}

